import React from 'react';

export const homeObjOne = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Ghana Headquartered · Est. 2015',
  headline: "Building Tomorrow's Ghana, Today.",
  description: "An innovative conglomerate creating meaningful employment across Agriculture, Technology, Infrastructure, and Services energizing Africa's greatest resource: its people.",
  buttonLabel: 'Our Sectors',
  imgStart: '',
  img: require('../../images/hero.jpg'),
  alt: 'Allday Ventures Ghana',
  start: '',
};

export const homeObjTwo = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Our Mission',
  headline: "Creating Sustainable Jobs That Energize Ghana's Workforce.",
  description: "We are focused on overcoming the canker of unemployment by creating lasting opportunities across Agriculture & Agri-business, Technology, Infrastructure, and Services.",
  buttonLabel: 'Learn More',
  imgStart: '',
  img: require('../../images/mission.jpg'),
  alt: 'Allday Ventures Mission',
  start: '',
};

export const homeObjThree = {
  primary: false,
  lightBg: true,
  lightTopLine: false,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Mr. Kofi Appiah — CEO, Allday Ventures',
  headline: "We believe Ghana's greatest asset is its people.",
  description: "Every venture we build is a vessel for unlocking that potential — creating opportunities that last, and legacies that matter. Allday Ventures is committed to the manifestation of the dominion mandate through Love.",
  buttonLabel: 'Our Story',
  imgStart: 'start',
  img: require('../../images/ceo.jpg'),
  alt: 'Kofi Appiah CEO Allday Ventures',
  start: 'true',
};

export const homeObjFour = {
  primary: true,
  lightBg: false,
  lightTopLine: true,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Our Values',
  headline: 'Service. Equity. Sustainability.',
  description: (
    <>
      Service to our people, Equity in our opportunities, and Sustainability in our solutions.{' '}
      These are the principles that guide every decision we make at Allday Ventures.{' '}
      Contact us on WhatsApp: <strong>+233 20 560 1679</strong>
    </>
  ),
  buttonLabel: 'Get in Touch',
  imgStart: 'start',
  img: require('../../images/values.jpg'),
  alt: 'Allday Ventures Values',
  start: 'true',
  url: 'https://wa.me/233205601679',
};